"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

require("./Title.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Title = function Title(props) {
  return /*#__PURE__*/_react["default"].createElement(_antd.Typography.Title, props);
};

var _default = Title;
exports["default"] = _default;